"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestService = http.create();
const RequestbaseURL = http.create({baseURL:Config.BASEURL});
export default {
    //获取详情
    getDetail(serialNumber){
        return RequestService.get('inspect/detail',serialNumber)
    },
    //巡检记录页面点击查看时获取详情
    getViewDetail(id){
        // console.log(id,'id');
        return RequestService.get('task/inspect/detail',id)
    },
    //新增巡检
    addInspection(params){
        return RequestService.post('inspect/add',params)
    },

    updateInspection(params){
    return RequestService.post('inspect/update',params)
},
    //巡检计划列表
    getInspectionList(params){
        return RequestService.post('inspect/list',params)
    },
    //删除巡检
    deleteInspection(id){
        return RequestService.get('inspect/del',id)
    },
    // task/del
    //删除待办
    deleteAgency(id){
        return RequestService.get('task/del',id)
    },
    //启动巡检
    operatorInspection(params){
        return RequestService.post('inspect/operator',params)
    },
    //巡检待办列表
    getAgencyList(params){
        return RequestService.post('task/list',params)
    },
    //填写巡检表单
    registerTable(params){
        return RequestService.post('task/inspect',params)
    },
    //巡检记录列表
    getRecordList(params){
        return RequestService.post('task/inspect/list',params)
    },
    // 获取服务组
    getDepartmentList:function () {
        return RequestbaseURL.get('itsm/v2/organization/department/tree/children',{ departmentId:99999,type:'group'})},
    // 繁忙度统计---组繁忙度
    busynessGroup:function (departmentId) {
        return RequestService.get("organization/group/busyness",{ departmentId:departmentId })
    },
    // 繁忙度统计---人员繁忙度
    busynessUser:function (userId) {
        return RequestbaseURL.get("itsm/v2/organization/user/busyness",{ internalUserid:userId })
    },
    //巡检日历
    inspectionCalendar:function (params) {
        return RequestService.get('task/mycanlendar',params)

    }
}
